import { Typography } from "@hellocarbo/lasagne";
import { Widget } from "@typeform/embed-react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import PageWrapper from "@/components/ui/PageWrapper";
import { UserContext } from "@/contexts";

function SubscriptionOptions() {
  const { t } = useTranslation("options");
  const { user } = useContext(UserContext);

  const email = user?.email || "";
  const company = user?.company?.name || "";

  const searchParams = new URLSearchParams(window.location.search);
  const optionKey = searchParams.get("option") || "";
  const option = t(`options:optionsList.${optionKey}.title`);

  return (
    <PageWrapper>
      <div className="mx-xl my-lg min-h-screen">
        <Typography step="3" as="h1" weight="bold" className="mb-sm">
          {t("options:title")}
        </Typography>

        <div className="mt-md">
          <Widget
            id="PepaCSP4"
            hidden={{ email, company, option }}
            style={{ width: "100%", height: "600px" }}
          />
        </div>
      </div>
    </PageWrapper>
  );
}

export default SubscriptionOptions;
